.co{aspect-ratio:1/1;}